<ng-container *ngIf="state$ | async as state">
  <div *ngIf="state.visible" class="view-mode-toggle" role="group" aria-label="Record view">
    <button
      *ngFor="let mode of state.availableModes"
      type="button"
      class="btn btn-sm"
      [class.btn-primary]="state.mode === mode"
      [class.btn-ghost-secondary]="state.mode !== mode"
      [attr.aria-pressed]="state.mode === mode"
      [attr.aria-label]="'Show ' + label(mode).toLowerCase() + ' view'"
      (click)="setMode(mode)">
      {{ label(mode) }}
    </button>
  </div>
</ng-container>
